module.exports = "/assets/data/a2e2c2570a727cd10adb1faad24b541c-KT23.data.json";